@import 'styles/mixins';
@import 'styles/variables';

.colorSection {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.preview {
  padding: 8px 20px;
  background-color: var(--dark-4);
  border: 1px solid var(--dark-10);
  border-radius: 8px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.previewHeader {
  font-size: 12px;
  color: var(--dark-40);
}

.previewContent {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
}

.toggleRow {
  display: flex;
  align-items: center;
  gap: 12px;
}

.previewToggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 48px;
  height: 24px;
  background-color: var(--toggle-bg);
  border-radius: 12px;
  position: relative;
  transition: background-color 0.2s;
  box-shadow: inset 0 1px 0 rgba(19, 21, 26, 0.12);
}

.toggleKnob {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  transition: 0.2s;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

  &[data-checked='true'] {
    left: calc(100% - 3px);
    transform: translateX(-100%);
  }
}

.toggleLabel {
  @include md-medium;
  color: var(--dark-90);
}

.previewButton {
  flex: 1;
  padding: 10px 16px;
  border: 2px solid var(--preview-bg);
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  background-color: var(--preview-bg);
  color: var(--preview-text);
  cursor: pointer;
  transition: opacity 0.2s ease;
  user-select: none;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
}

// Color Picker Input
.colorInputContainer {
  display: flex;
  justify-content: center;
  width: 100%;
}

.inputField {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--light-100);
  border: 1px solid var(--dark-10);
  border-radius: 8px;
  width: 100%;
  height: 48px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--selected-fill);
    box-shadow: 0 0 0 1px var(--selected-fill);
  }
}

.colorCircle {
  width: 24px;
  height: 24px;
  border: 1px solid var(--dark-10);
  border-radius: 50%;
  flex-shrink: 0;
}

.hash {
  color: var(--dark-40);
  font-weight: 500;
  font-size: 16px;
}

.hexValue {
  @include lg-regular;
  color: var(--dark-40);
  letter-spacing: 0.5px;
}

.pickerWrapper {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  :global {
    .react-colorful {
      width: 100%;
    }

    .react-colorful__saturation {
      margin-bottom: 5px;
      border-radius: 5px;
      height: 180px;
    }

    .react-colorful__hue {
      height: 10px;
      border-radius: 5px;
    }

    .react-colorful__saturation-pointer {
      width: 18px;
      height: 18px;
    }

    .react-colorful__hue-pointer {
      width: 16px;
      height: 16px;
    }
  }
}

.pickerHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
}

.hexInputInPicker {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px;
  background: var(--light-100);
  border: 1px solid var(--dark-15);
  border-radius: 6px;
  flex-shrink: 0;
}

.colorCircleInPicker {
  width: 21px;
  height: 21px;
  border: 1px solid var(--dark-8);
  border-radius: 50%;
  flex-shrink: 0;
}

.hexInputWrapper {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0 2px 2px;
}

.hashInPicker {
  color: var(--dark-80);
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.28px;
  line-height: 1.3;
}

.hexInput {
  border: none;
  outline: none;
  background: transparent;
  color: var(--dark-80);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.28px;
  line-height: 1.3;
  text-transform: uppercase;
  width: 60px;

  &:focus {
    outline: none;
  }
}

.resetButton {
  padding: 8px 14px;
  background: var(--light-100);
  border: 1px solid var(--dark-8);
  border-radius: 6px;
  color: var(--dark-80);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.28px;
  line-height: 1.39;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: var(--dark-4);
    border-color: var(--dark-15);
  }

  &:active {
    background: var(--dark-8);
  }
}

.colorPickerPopover {
  overflow: visible;
  box-shadow: 0px 8px 37px 0px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--dark-10);
  border-radius: 10px;
  width: 100%;
  max-width: 390px;
}
